import { MoreVerticalIcon } from "lucide-react";
import { useNavigate } from "react-router-dom";

import { Button } from "@/components/ui/button";
import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";

type SessionRowActionsProps = {
  sessionId: string;
};

export function SessionRowActions(props: SessionRowActionsProps) {
  const navigate = useNavigate();

  const handleSessionEdit = () => {
    navigate(`/sessions/${props.sessionId}`);
  };

  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger asChild>
        <Button variant="ghost" size="icon">
          <MoreVerticalIcon />
        </Button>
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end">
        <DropdownMenuItem onClick={handleSessionEdit}>View</DropdownMenuItem>
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
